import styled from 'styled-components';

export const User = styled.div`
  display: flex;
  align-items: center;
`;

export const MetaInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1.6rem;
`;

export const UserName = styled.span`
  ${(props) => props.theme.fonts.interSemibold16};
  color: ${(props) => props.theme.colors.white100};
`;

export const Location = styled.span`
  ${(props) => props.theme.fonts.interSemibold13};
  color: ${(props) => props.theme.colors.secondary};
  line-height: unset;
  margin-top: .3rem;
  display: flex;
  align-items: center;
  gap: .4rem;
`;
